import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

const env = import.meta.env;

const staffAuthority = `https://login.microsoftonline.com/${env.VITE_ENTRA_STAFF_TENANT_ID}`;

export const staffMsalConfig: Configuration = {
  auth: {
    clientId: env.VITE_ENTRA_STAFF_CLIENT_ID,
    authority: staffAuthority,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: { cacheLocation: 'localStorage' },
  system: { loggerOptions: { logLevel: LogLevel.Warning, piiLoggingEnabled: false, loggerCallback: () => {} } },
};

export const staffPca = new PublicClientApplication(staffMsalConfig);
export const staffScopes = ['openid', 'profile', 'email'];

// Comma-separated list of email domains routed to staff SSO (the
// single-tenant Entra app above) instead of the client sign-in flow.
// Defaults to mountinsights.com so local/unset env behaves the same as
// before. To admit a staff member on another domain, add their domain
// here (VITE_STAFF_EMAIL_DOMAINS env var / STAFF_EMAIL_DOMAINS repo
// variable in deploy-frontend.yml) *and* invite their account as a guest
// in the Mount Insights Entra tenant (Entra ID -> Users -> Invite external
// user) -- this check alone doesn't grant them access, it only decides
// which login flow the browser attempts.
const staffEmailDomains: string[] = String(env.VITE_STAFF_EMAIL_DOMAINS || 'mountinsights.com')
  .split(',')
  .map((d: string) => d.trim().toLowerCase())
  .filter(Boolean);

export function isStaffEmail(email: string): boolean {
  const domain = email.trim().toLowerCase().split('@').pop() ?? '';
  return staffEmailDomains.includes(domain);
}
